/**
 * Polyfills para corrigir problemas de compatibilidade com Mapbox GL
 */

// Polyfill para BigInt (necessário para Mapbox GL em browsers antigos)
if (typeof BigInt === 'undefined') {
  // Implementação básica de BigInt para compatibilidade
  (window as any).BigInt = function(value: any) {
    if (typeof value === 'string') {
      return parseInt(value, 10);
    }
    return Number(value);
  };
  
  // Adiciona suporte para literais BigInt (como 96n)
  (window as any).BigInt.prototype = Number.prototype;
}

// Polyfill adicional para garantir compatibilidade com operações BigInt
if (typeof (window as any).BigInt !== 'undefined') {
  const originalBigInt = (window as any).BigInt;
  (window as any).BigInt = function(value: any) {
    try {
      return originalBigInt(value);
    } catch (e) {
      // Fallback para números normais se BigInt falhar
      return Number(value);
    }
  };
}

// Polyfill para window.URL (necessário para Mapbox GL)
(window as any).URL = window.URL || window.webkitURL;

// Necessário para o Mapbox GL em alguns ambientes
if (!window.ResizeObserver) {
  window.ResizeObserver = class ResizeObserver {
    constructor(callback: any) {
      this.callback = callback;
    }
    callback: any;
    observe(target: any): void {
      // Implementação simples
    }
    unobserve(target: any): void {
      // Implementação simples
    }
    disconnect(): void {
      // Implementação simples
    }
  };
}

// Necessário para o mapbox-gl
(window as any).process = { env: {} }; 